import Start from "../views/user/start";
import Step1 from "../views/user/step1";
import Step2 from "../views/user/step2";
import Step3 from "../views/user/step3";
import Step4 from "../views/user/step4";
import SelectionListing from "../views/user/selectionListing";
import loadingScreen from "../views/user/loadingScreen";
import Congratulation from "../views/user/congratulation";
import Dashboard from "../views/user/dashboard";
import invitation from "../views/user/invitation";

const routes = [
    {
        path: "/index",
        name: "Start",
        icon: "fas fa-chart-line text-orange",
        component: Start,
        layout: "/easy-flow",
        display: false,
    },
    {
        path: "/step1",
        name: "Step 1",
        icon: "fas fa-chart-line text-orange",
        component: Step1,
        layout: "/easy-flow",
        display: false,
    },
    {
        path: "/step2",
        name: "Step 2",
        icon: "fas fa-chart-line text-orange",
        component: Step2,
        layout: "/easy-flow",
        display: false,
    },
    {
        path: "/step3",
        name: "Step 3",
        icon: "fas fa-chart-line text-orange",
        component: Step3,
        layout: "/easy-flow",
        display: false,
    },
    {
        path: "/step4",
        name: "Step 4",
        icon: "fas fa-chart-line text-orange",
        component: Step4,
        layout: "/easy-flow",
        display: false,
    },
    {
        path: "/selectionList",
        name: "Selection List",
        icon: "fas fa-chart-line text-orange",
        component: SelectionListing,
        layout: "/easy-flow",
        display: false,
    },
    {
        path: "/step4/loading",
        name: "Loading",
        icon: "fas fa-chart-line text-orange",
        component: loadingScreen,
        layout: "/easy-flow",
        display: false,
    },
    {
        path: "/step4/congratulation",
        name: "Congratulation",
        icon: "fas fa-chart-line text-orange",
        component: Congratulation,
        layout: "/easy-flow",
        display: false,
    },
    {
        path: "/dashboard",
        name: "Dashboard",
        icon: "fas fa-chart-line text-orange",
        component: Dashboard,
        layout: "/easy-flow",
        display: false,
    },
    {
        path: "/invitation",
        name: "Invitation",
        icon: "fas fa-chart-line text-orange",
        component: invitation,
        layout: "/easy-flow",
        display: false,
    },
];

export default routes;